var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { "data-scroll-container": "" } }, [
      _c("div", { attrs: { "data-scroll-section": "" } }, [
        _c("div", {
          staticClass:
            "elfsight-app-19e3ae0f-19be-474a-a173-d81a74c5c8ba text-center mb-12",
          attrs: { "data-elfsight-app-lazy": "" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }